export const UPDATE_I18N = "UPDATE_I18N";

export const updateI18n = (value) => ({
  type: UPDATE_I18N,
  value,
});
